import * as angular from "angular";
import { Webhook } from '../models/webhook.model';
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {WebhooksAlerts} from "./webhooks-alerts.service";
import {WebhooksRequests} from "./webhooks-requests.service";

export class WebhooksService {

  /* @ngInject */
  constructor(private webhooksAlerts: WebhooksAlerts, private webhooksRequests: WebhooksRequests,
              private $log, private bringozLoaderService: BringozLoaderService) {
  }

  getAll() {
    return this.webhooksRequests.getAll()
      .then((webhooks) => {
        return webhooks;
      })
      .catch((err) => {
        this.$log.error('Failed to get Webhooks', err);
      })
  }

  create(webhook: Webhook, $event) {
        this.bringozLoaderService.on();
        return this.webhooksRequests.create(webhook)
          .then((newWebhook) => {
            this.webhooksAlerts.createSuccess();
            return newWebhook;
          })
      .catch((err) => {
        this.$log.error('Failed to create webhook', err);
        this.webhooksAlerts.createError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  edit(updatedWebhook: Webhook, $event) {
        this.bringozLoaderService.on();
        return this.webhooksRequests.update(updatedWebhook.id, updatedWebhook)
          .then((updatedWebhook) => {
            this.webhooksAlerts.updateSuccess();
            return updatedWebhook;
          })
      .catch((err) => {
        this.$log.error('Failed to update webhook', err)
        this.webhooksAlerts.updateError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  remove(id) {
    this.bringozLoaderService.on();
    return this.webhooksRequests.remove(id)
      .then((deletedWebhook) => {
        this.webhooksAlerts.deleteSuccess();
        return deletedWebhook;
      })
      .catch((error) => {
        this.$log.error('Failed to delete the webhook', error);
        this.webhooksAlerts.deleteError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

}

angular
  .module('bringoz.admin.webhooks')
  .service('webhooksService', WebhooksService);
